import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { NODE_UI, stopPropagation } from './nodeUiStyles';

/**
 * NodeAddButton — "+ Add" button for appending items to a repeatable list.
 * Ghost/outline style, compact, monotone.
 *
 * Usage:
 *   <NodeAddButton onClick={handleAddItem} label="Add Output" />
 */

const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontSize: NODE_UI.fontSize.value,
  fontWeight: NODE_UI.fontWeight.label,
  color: theme.palette.text.secondary,
  borderColor: theme.palette.divider,
  borderRadius: NODE_UI.borderRadiusSm,
  borderStyle: 'dashed',
  padding: '4px 12px',
  minHeight: '32px',
  lineHeight: 1.4,
  '&:hover': {
    borderColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.hover,
  },
}));

const NodeAddButton = React.memo(function NodeAddButton({
  onClick,
  label = 'Add',
  icon,
  disabled = false,
  fullWidth = true,
  sx,
}) {
  return (
    <StyledButton
      variant="outlined"
      startIcon={icon || <AddIcon sx={{ fontSize: '16px !important' }} />}
      onClick={(e) => {
        stopPropagation(e);
        onClick?.(e);
      }}
      onMouseDown={stopPropagation}
      onPointerDown={stopPropagation}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={sx}
    >
      {label}
    </StyledButton>
  );
});

export default NodeAddButton;
